import React, { useState, useEffect } from "react";
import Header from "../../../components/Header";
import LeftMenu from "../../../components/LeftMenu";
import { CARD_STYLE } from "../../../constants/styles";
import { GREY_GRADIENT_PANEL_BACKGROUND } from "../../../constants/styles";
import { ADMIN_PANEL_BACKGROUND_COLOR } from "../../../constants/styles";
import { functions } from "../../../constants/common-functions";

import QuestionnaireModeSelector from "../QuestionnaireModeSelector";
import ResponseDetailModal from "./components/ResponseDetailModal";

export default function QuestionnaireQuestionResponses() {

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedResponseId, setSelectedResponseId] = useState(null);
  const [responses, setResponses] = useState([]);

  const [filters, setFilters] = useState({
    user: "",
    questionnaire: "",
    fromDate: "",
    toDate: ""
  });

  const cardHeader = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "13px",
    fontWeight: "600",
    color: "#333",
    marginBottom: "10px",
    padding: "20px"
  };

  const labelStyle = {
    fontSize: "12px",
    color: "#666",
    marginBottom: "4px",
    marginLeft: "20px"
  };

  const inputStyle = {
    padding: "6px 8px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "12px",
    marginLeft: "20px"
  };

  const buttonStyle = {
    padding: "6px 14px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    background: "linear-gradient(180deg, #f4f6f8, #e6e8eb)",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: "600"
  };

  const searchResponses = () => {

    let query = "/resolutionsoftwareplatform/questionnaire/response/search?";

    if (filters.user) {
      query += "user=" + encodeURIComponent(filters.user) + "&";
    }
    if (filters.questionnaire) {
      query += "questionnaire=" + encodeURIComponent(filters.questionnaire) + "&";
    }
    if (filters.fromDate) {
      query += "fromDate=" + filters.fromDate + "&";
    }
    if (filters.toDate) {
      query += "toDate=" + filters.toDate + "&";
    }

    functions.getArrayFromAjax(query, setResponses);
  };

  // Initial load
  useEffect(() => {
    searchResponses();
  }, []);

  const openResponse = (responseId) => {
    setSelectedResponseId(responseId);
    setModalOpen(true);
  };

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", width: "calc(100% - 60px)", marginLeft: "60px", marginTop: "60px" }}>
        <Header />
        <LeftMenu />

        {/* SEARCH CARD */}
        <div style={{ ...CARD_STYLE, margin: "30px", flexDirection: "column", paddingBottom: "20px", background: GREY_GRADIENT_PANEL_BACKGROUND }}>
          <div style={cardHeader}>Search Responses</div>

          <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div style={labelStyle}>User</div>
              <input
                style={inputStyle}
                placeholder="User name"
                value={filters.user}
                onChange={(e) => setFilters({ ...filters, user: e.target.value })}
              />
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
              <div style={labelStyle}>Questionnaire</div>
              <input
                style={inputStyle}
                placeholder="Questionnaire name"
                value={filters.questionnaire}
                onChange={(e) => setFilters({ ...filters, questionnaire: e.target.value })}
              />
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
              <div style={labelStyle}>From Date</div>
              <input
                style={inputStyle}
                type="date"
                value={filters.fromDate}
                onChange={(e) => setFilters({ ...filters, fromDate: e.target.value })}
              />
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
              <div style={labelStyle}>To Date</div>
              <input
                style={inputStyle}
                type="date"
                value={filters.toDate}
                onChange={(e) => setFilters({ ...filters, toDate: e.target.value })}
              />
            </div>

            <div style={{ display: "flex", alignItems: "flex-end" }}>
              <button style={buttonStyle} onClick={searchResponses}>Search</button>
            </div>
          </div>
        </div>

        {/* RESPONSES LIST */}
        <div style={{ ...CARD_STYLE, margin: "0 30px 30px 30px", flexDirection: "column", background: ADMIN_PANEL_BACKGROUND_COLOR }}>

          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
            <thead style={{ height: "40px", background: GREY_GRADIENT_PANEL_BACKGROUND, borderBottom: "1px solid #000" }}>
              <tr style={{ textAlign: "left", color: "#666" }}>
                <th style={{ padding: "8px", paddingLeft: "20px" }}>Questionnaire</th>
                <th style={{ padding: "8px" }}>User</th>
                <th style={{ padding: "8px" }}>Date</th>
                <th style={{ padding: "8px" }}>Status</th>
                <th style={{ padding: "8px" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {responses.map((r) => (
                <tr key={r.responseId} style={{ borderTop: "1px solid #eee" }}>
                  <td style={{ padding: "8px", paddingLeft: "20px" }}>{r.questionnaireTitle}</td>
                  <td style={{ padding: "8px" }}>{r.username}</td>
                  <td style={{ padding: "8px" }}>{r.responseDate}</td>
                  <td style={{ padding: "8px" }}>{r.status}</td>
                  <td style={{ padding: "8px" }}>
                    <button style={buttonStyle} onClick={() => openResponse(r.responseId)}>View</button>
                  </td>
                </tr>
              ))}
              {responses.length === 0 && (
                <tr>
                  <td colSpan="5" style={{ padding: "12px", textAlign: "center", color: "#999" }}>
                    No responses found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

      </div>

      <ResponseDetailModal
        open={modalOpen}
        responseId={selectedResponseId}
        onClose={() => setModalOpen(false)}
        onReissue={() => alert("Re-issued! (dummy)")}
      />

      <QuestionnaireModeSelector displayFlag="flex" />
    </>
  );
}
